import { styled } from '@mui/material/styles';
import { Button } from "@mui/material";
import { BrandColors } from '../utils';

export const BrandButton = styled(Button)({
    backgroundColor: BrandColors.brandGreen,
    color: '#fff',
    '&:hover': {
        backgroundColor: BrandColors.brandDarkGreen,
        borderColor: '#0062cc',
      },
      '&:active': {
        backgroundColor: BrandColors.brandDarkGreen,
        borderColor: '#005cbf',
      },
})

export const BrandButtonWhite = styled(Button)({
  backgroundColor: '#fff',
  borderColor: BrandColors.brandGreen,
  color: BrandColors.brandGreen,
  '&:hover': {
      backgroundColor: '#fff',
      borderColor: BrandColors.brandGreen,
    },
    '&:active': {
      backgroundColor: '#fff',
      borderColor: BrandColors.brandGreen,
    },
})

export const BrandButtonGray = styled(Button)({
  backgroundColor: BrandColors.brandDarkGray,
  color: '#fff',
  '&:hover': {
      backgroundColor: BrandColors.brandDarkGray,
      borderColor: '#0062cc',
    },
    '&:active': {
      backgroundColor: BrandColors.brandDarkGray,
      borderColor: '#005cbf',
    },
})

export const BrandBlackWhite = styled(Button)({
  backgroundColor: '#000',
  borderColor: '#000',
  color: '#fff',
  '&:hover': {
      backgroundColor: '#000',
      borderColor: BrandColors.brandLightGreen,
    },
    '&:active': {
      backgroundColor: '#000',
      borderColor: BrandColors.brandLightGreen,
    },
})